import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { indicatorsSelector } from '../store/selectors/category/ui';
import { arrayify } from '../utils/array/array';
import { STATE_NEW, STATE_UNPUBLISHED } from '../utils/category/states';
import { NodeBase } from '../entities/Node';
import { RootState } from '../store';
import { Category } from '../entities/Category';

export function usePublishIndicators(node: NodeBase) {
  const publishState = node?.category?.publishState;
  const props = useMemo(() => {
    const isNew = node?.category?.newCategory;
    const state = isNew && publishState === STATE_UNPUBLISHED ? null : publishState;
    const indicators = [...arrayify(state)];
    if (isNew) {
      indicators.unshift(STATE_NEW);
    }

    return {
      badges: indicators,
    };
  }, [node, publishState]);

  return props;
}

export function useAllIndicators(catalogId: string, content: Category) {
  return useSelector((state: RootState) =>
    indicatorsSelector(state, catalogId, content),
  );
}
